"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHumanReadable = exports.fromMoments = void 0;
var moment_1 = __importDefault(require("moment"));
/**
 * Calculates the duration between 2 moments
 * @param m1 Start moment
 * @param m2 End moment
 * @returns Duration between start and end moments
 * @deprecated Will be removed in a future major version
 */
var fromMoments = function (m1, m2) { return moment_1.default.duration(m1.diff(m2)); };
exports.fromMoments = fromMoments;
/**
 * Converts a duration to a human readable string
 * @param duration Duration as moment duration object or number to be passed into moment duration constructor
 * @param options Render options
 */
var toHumanReadable = function (duration, options) {
    if (options === void 0) { options = {
        seconds: true,
        milliseconds: false,
    }; }
    duration = typeof duration === 'number' ? moment_1.default.duration(duration) : duration;
    var hours = Math.floor(duration.asHours());
    var str = "".concat(String(hours).padStart(2, '0'), ":").concat(String(duration.minutes()).padStart(2, '0'));
    if (options.seconds) {
        str = "".concat(str, ":").concat(String(duration.seconds()).padStart(2, '0'));
        if (options.milliseconds) {
            str = "".concat(str, ".").concat(String(duration.milliseconds()).padStart(3, '0'));
        }
    }
    return str;
};
exports.toHumanReadable = toHumanReadable;
//# sourceMappingURL=duration.js.map